export const TABS = ["all", "awaiting", "done"];
export const DEFAULT_TAB = "awaiting";

export const KINDS = {
  in: {
    title: "Checking In Today",
    labels: { all: "All", awaiting: "Awaiting check-in", done: "Checked in" },
    nobody: "No dogs arriving today",
    allDone: "Everyone has checked in",
    noneDone: "No one has checked in yet",
  },
  out: {
    title: "Checking Out Today",
    labels: { all: "All", awaiting: "Awaiting check-out", done: "Checked out" },
    nobody: "No dogs departing today",
    allDone: "Everyone has checked out",
    noneDone: "No one has checked out yet",
  },
  facility: {
    title: "In Facility Today",
    tabs: false,
    sorted: false,
    nobody: "No dogs checked in right now",
    allDone: "No dogs checked in right now",
    noneDone: "No dogs checked in right now",
  },
};

export function hasTabs(kind) {
  return KINDS[kind].tabs !== false;
}

export function isSorted(kind) {
  return KINDS[kind].sorted !== false;
}

export function stateFor({ checkedIn, checkedOut }) {
  if (checkedOut) return "out";
  if (checkedIn) return "in";
  return "none";
}

export function isDone(kind, state) {
  return kind === "in" ? state !== "none" : state === "out";
}

export function matchesTab(kind, tab, state) {
  if (tab === "all") return true;
  return tab === "done" ? isDone(kind, state) : !isDone(kind, state);
}

export function tally(kind, states) {
  const done = states.filter((state) => isDone(kind, state)).length;
  return { all: states.length, awaiting: states.length - done, done };
}

export function tabLabel(kind, tab, counts) {
  const label = KINDS[kind].labels[tab];
  return counts ? `${label} (${counts[tab]})` : label;
}

function plural(count, word) {
  return `${count} ${word}${count === 1 ? "" : "s"}`;
}

export function summaryLabel(dogs, bookings, { sorted = true, notCheckedIn = 0 } = {}) {
  const parts = [plural(dogs, "dog"), plural(bookings, "booking")];
  if (notCheckedIn > 0) parts.push(`${notCheckedIn} not checked in`);
  if (sorted) parts.push("sorted by time");
  return parts.join(" · ");
}

export function toggleLabel(petName, state) {
  if (state === "none") return `Check in ${petName}`;
  if (state === "in") return `Check out ${petName}`;
  return `Reset ${petName}'s attendance`;
}

export function normalizeQuery(value) {
  return String(value == null ? "" : value).trim();
}

export function matchesQuery(fields, query) {
  const needle = normalizeQuery(query).toLowerCase();
  if (!needle) return true;

  return fields.some((field) => String(field == null ? "" : field).toLowerCase().includes(needle));
}

export function resultLabel(count) {
  return `${count} result${count === 1 ? "" : "s"}`;
}

export function noMatchesMessage(query) {
  return `No matches for \u201c${normalizeQuery(query)}\u201d`;
}

export function emptyMessage(kind, tab, counts, query = "") {
  if (normalizeQuery(query)) return noMatchesMessage(query);

  const copy = KINDS[kind];
  if (!counts || counts.all === 0) return copy.nobody;
  return tab === "awaiting" ? copy.allDone : copy.noneDone;
}

export function nextTab(current, key) {
  const index = TABS.indexOf(current);
  if (key === "ArrowRight") return TABS[(index + 1) % TABS.length];
  if (key === "ArrowLeft") return TABS[(index + TABS.length - 1) % TABS.length];
  if (key === "Home") return TABS[0];
  if (key === "End") return TABS[TABS.length - 1];
  return null;
}

export function placePanel({ anchor, container, panelWidth, panelHeight, gap = 8 }) {
  const maxLeft = Math.max(0, container.width - panelWidth);
  const left = Math.min(Math.max(0, anchor.left - container.left), maxLeft);
  const fitsAbove = anchor.top >= panelHeight + gap;

  if (fitsAbove) {
    return { side: "up", left, bottom: container.bottom - anchor.top + gap };
  }

  return { side: "down", left, top: anchor.bottom - container.top + gap };
}
